<template>
  <div class="loader" v-if="loading"></div>
</template>

<script>
export default {
  name: "loaderSpinner",
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.loader {
  position: fixed;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  background-color: #eceaea;
  /* background-image: url('https://onconnect-sitr.suezsmartsolutions.com/SITR/Supervision/Images/ajax-loader.gif'); */
  background-image: url("../assets/img/loader1.gif");
  background-size: 50px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 10000000;
  opacity: 0.4;
  filter: alpha(opacity=40);
}
</style>
